if($('html[lang="sk"]').length){
    var ratingUrl = '/hodnotenie-obchodu/'
    var productCare = 'Používanie a ošetrovanie produktov'
    var productCareUrl = '/pouzivanie-a-osetrovanie-produktov/'
    var vernostniProgram = '/vernostny-program/'
    var vernostniProgramImage = '/user/documents/upload/banners/vernostni-program-tinified.png'
}

if($('html[lang="cs"]').length){
    var ratingUrl = '/hodnoceni-obchodu/'
    var productCare = 'Jak správně pečovat o produkt?'
    var productCareUrl = '/pouzivanie-a-osetrovanie-produktov/'
    var vernostniProgram = '/vernostni-program/'
    var vernostniProgramImage = '/user/documents/upload/banners/vernostni-program-tinified.png'
}